import { pr } from '@/utils/pxToRem';
import { Typography, Stack } from '@mui/material';
import React from 'react';
import { style } from '@/styles/globals';
import Image from 'next/image';
import { loaderImageVex } from '@/utils/loadImageSeoVex';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';

const Applicaiton = ({ lang }: { lang: ILangObj }) => (
  <Stack spacing={pr`16px`}>
    <Typography
      component="div"
      sx={{
        fontWeight: '700',
        fontSize: '18px',
        lineHeight: '30px',
        color: `${style.color.black1}`,
      }}
    >
      {lang?.footer?.download || 'Tải ứng dụng VeXeRe'}
    </Typography>
    <Stack
      spacing={pr`20px`}
      marginTop={pr`23px`}
    >
      <Stack
        spacing={pr`16px`}
        flexWrap="wrap"
        justifyContent="flex-start"
        direction="column"
      >
        <div>
          <a
            target="_blank"
            href="https://itunes.apple.com/vn/app/vexere/id1183279479"
            rel="noreferrer"
          >
            <Image
              loader={loaderImageVex}
              src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Application/ios.svg"
              alt="logo"
              width="164px"
              height="48px"
              objectFit="contain"
            />
          </a>
        </div>
        <div>
          <a
            target="_blank"
            href="https://storage.googleapis.com/fe-production/images/landingpagetet2018/GP-icon.png?v=2"
            rel="noreferrer"
          >
            <Image
              loader={loaderImageVex}
              src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Application/android.svg"
              alt="logo"
              width="164px"
              height="48px"
              objectFit="contain"
            />
          </a>
        </div>
      </Stack>
    </Stack>
  </Stack>
);

export default Applicaiton;
